const LANGUAGES = {
  NO: 'norwegian',
  EN: 'english',
  UK: 'ukrainian'
}

const LANGUAGES_ORDER = ['NO', 'EN', 'UK']

export default LANGUAGES

export { LANGUAGES_ORDER, LANGUAGES }
